'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { SourcesContent } from '@/app/(protected)/sources/content';

export default function SourcesPageClient() {
  return (
    <Fragment>
      <Container>
        <SourcesContent />
      </Container>
    </Fragment>
  );
}
